<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 7a1 1 0 0 0 2 0V2.604a1 1 0 0 0 0-.046V2a1 1 0 0 0-1-1H2a1 1 0 1 0 0 2h2.343a9.003 9.003 0 0 0 2.282 15.345 1 1 0 0 0 .75-1.854A7.002 7.002 0 0 1 6 4.254V7Zm8 6a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-2.343a9.003 9.003 0 0 0-2.282-15.345 1 1 0 1 0-.75 1.853A7.003 7.003 0 0 1 14 15.746V13Z" />
    </svg>
</template>
